var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavBoardLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7002 0.219971L62.3401 5.14996C51.9601 19.1 43.9802 34.82 38.8202 51.43C33.6502 68.03 31.2901 85.51 31.8601 102.89C32.4201 120.27 35.9101 137.55 42.1801 153.77C48.4401 169.99 57.4601 185.13 68.7201 198.39L64.7302 201.78",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.25 6.08984L59.55 9.07983",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.97 10.0601L55.95 14.4901",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9302 15.9399L53.4402 18.6099",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9502 20.3599L50.2402 24.2699",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3301 26.21L48.0201 28.54",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7002 31.0601L45.2502 34.4301",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.49 36.8699L43.34 38.8499",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.23 42.1199L41.01 44.9199",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.49 47.8699L39.47 49.4899",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6201 53.48L37.5801 55.71",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.27 59.1199L36.36 60.3799",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8301 65.0701L34.9301 66.7201",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8701 70.5701L34.0401 71.4601",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8701 76.8301L33.0701 77.8901",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.29 82.1699L32.51 82.6799",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 88.7L32.01 89.1599",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6001 93.8501L31.8401 93.9801",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.55 100.62L31.8201 100.48",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 105.55L31.98 105.3",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1899 112.53L32.4299 111.79",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.72 117.21L32.92 116.58",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6802 124.35L33.8402 123.02",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.53 128.77L34.67 127.77",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.01 136.05L36.05 134.12",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.21 140.17L37.27 138.79",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.23 147.53L39.11 145.02",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.71 151.33L40.65 149.59",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.27 158.75L42.95 155.67",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M40 162.22L44.8 160.11",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1101 169.65L47.5401 166.01",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0701 172.77L49.7001 170.32",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.72 180.17L52.87 176",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9399 182.89L55.3799 180.11",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1301 190.23L58.9501 185.55",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.51 192.58L61.74 189.48",
    stroke: "#00CECE",
    strokeWidth: 0.213,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.22 199.81L65.69 194.65",
    stroke: "#00CECE",
    strokeWidth: 0.4261,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 197.42L27.21 197.43L28.17 197.95L27.77 198.38L26.57 197.72L26.22 197.19L30.86 194.16L31.26 194.77L27.2 197.42Z",
    fill: "#00CECE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4401 190.85C27.0401 189.86 28.2901 189.92 28.9401 190.96C29.5101 191.88 29.0301 193.04 27.4801 194.01C25.9001 194.98 24.6101 194.83 24.0201 193.88C23.4001 192.88 23.9401 191.77 25.4401 190.85ZM27.0901 193.37C28.3201 192.62 28.7801 191.81 28.4201 191.23C28.0201 190.58 27.0701 190.73 25.8601 191.47C24.7001 192.18 24.1201 192.95 24.5301 193.61C24.8701 194.17 25.8001 194.15 27.0901 193.37Z",
    fill: "#00CECE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 163L14.79 163.16L14.05 162.8C12.31 161.92 11.42 161.56 10.63 161.83C10.1 162.02 9.70002 162.45 9.98002 163.23C10.15 163.7 10.53 164.01 10.82 164.18L10.4 164.58C9.97001 164.33 9.56001 163.9 9.34001 163.29C8.94001 162.17 9.54002 161.42 10.29 161.15C11.25 160.81 12.28 161.23 13.73 161.95L14.26 162.23L14.28 162.22L13.44 159.88L14.03 159.67L15.22 163Z",
    fill: "#00CECE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94991 156.31C11.7399 155.72 12.9399 156.07 13.3199 157.23C13.6599 158.26 12.9199 159.27 11.1899 159.85C9.4299 160.43 8.20988 159.98 7.85988 158.92C7.48988 157.81 8.26991 156.86 9.94991 156.31ZM10.9599 159.14C12.3299 158.69 12.9699 158.02 12.7499 157.37C12.5099 156.64 11.5499 156.57 10.2099 157.01C8.91989 157.43 8.16991 158.04 8.41991 158.78C8.61991 159.4 9.52989 159.61 10.9599 159.14Z",
    fill: "#00CECE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04996 130.32C6.15996 130.09 6.29998 129.57 6.22998 129.06C6.09998 128.11 5.45997 127.89 4.99997 127.96C4.22997 128.07 3.99996 128.81 4.08996 129.53L4.14996 129.94L3.58996 130.01L3.53998 129.6C3.46998 129.06 3.09998 128.41 2.44998 128.5C2.00998 128.56 1.65997 128.89 1.74997 129.57C1.80997 130.01 2.05998 130.41 2.25998 130.62L1.74997 130.89C1.49997 130.63 1.21998 130.1 1.13998 129.51C0.999983 128.43 1.56996 127.85 2.23996 127.77C2.80996 127.69 3.32998 127.97 3.66998 128.61H3.68997C3.73997 127.92 4.16997 127.3 4.93997 127.2C5.81997 127.08 6.67997 127.66 6.84997 128.98C6.92997 129.6 6.80998 130.16 6.66998 130.46L6.04996 130.32Z",
    fill: "#00CECE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17003 122.74C5.04003 122.54 6.15001 123.13 6.28001 124.35C6.39001 125.43 5.46003 126.26 3.64003 126.47C1.79003 126.67 0.690019 125.98 0.570019 124.86C0.450019 123.69 1.42003 122.92 3.17003 122.74ZM3.57002 125.72C5.00002 125.57 5.77002 125.04 5.70002 124.36C5.62002 123.6 4.69002 123.33 3.29002 123.48C1.94002 123.62 1.08002 124.07 1.16002 124.84C1.23002 125.49 2.07002 125.88 3.57002 125.72Z",
    fill: "#00CECE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81003 94.4498L4.31003 94.3298L4.11002 96.8998L3.62003 96.8598L0.290039 94.1198L0.350037 93.3098L3.78003 93.5798L3.84003 92.8098L4.43002 92.8598L4.37003 93.6298L5.87003 93.7498L5.81003 94.4498ZM3.72003 94.2898L1.88004 94.1498C1.59004 94.1298 1.30002 94.0998 1.02002 94.0598V94.0798C1.33002 94.2798 1.56002 94.4298 1.80002 94.5998L3.57004 96.0998H3.59003L3.72003 94.2898Z",
    fill: "#00CECE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55011 88.49C5.4201 88.69 6.38012 89.49 6.25012 90.71C6.14012 91.79 5.05013 92.41 3.23013 92.23C1.38013 92.04 0.450125 91.13 0.570125 90.01C0.690125 88.85 1.80011 88.3 3.55011 88.49ZM3.32012 91.49C4.75012 91.64 5.61011 91.29 5.68011 90.61C5.76011 89.85 4.91012 89.39 3.50012 89.24C2.15012 89.1 1.22013 89.35 1.14013 90.12C1.07013 90.77 1.82012 91.33 3.32012 91.49Z",
    fill: "#00CECE"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3399 53.7899L8.66992 55.7899L9.94992 56.4398C9.96992 56.3098 9.99991 56.1898 10.0599 55.9998C10.1999 55.5998 10.4199 55.2198 10.7199 54.9598C11.0899 54.6298 11.6599 54.4399 12.3199 54.6599C13.3499 54.9999 13.8399 56.0798 13.4599 57.2098C13.2699 57.7798 12.9399 58.2099 12.6999 58.4099L12.2199 58.0498C12.4199 57.8798 12.7299 57.4998 12.8899 57.0198C13.1099 56.3498 12.8699 55.6298 12.1699 55.3998C11.4899 55.1798 10.8499 55.4698 10.4999 56.5198C10.3999 56.8198 10.3499 57.0598 10.3099 57.2698L7.8999 56.0898L8.7399 53.5798L9.3399 53.7899Z",
    fill: "#00CECE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12.94 49.9499C14.71 50.5999 15.44 51.6099 15.02 52.7599C14.65 53.7799 13.45 54.1199 11.72 53.4999C9.98003 52.8599 9.29002 51.7598 9.68002 50.7098C10.08 49.6098 11.28 49.3399 12.94 49.9499ZM11.98 52.7998C13.33 53.2898 14.25 53.1598 14.49 52.5198C14.75 51.7998 14.04 51.1499 12.71 50.6699C11.43 50.1999 10.47 50.2199 10.2 50.9499C9.98004 51.5599 10.57 52.2798 11.98 52.7998Z",
    fill: "#00CECE"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0299 11.6698C30.9299 11.7898 30.8299 11.9598 30.7299 12.1498C30.2099 13.2198 30.5599 14.2298 31.2299 14.8598L31.2399 14.8398C31.1099 14.4198 31.1399 13.8798 31.4899 13.3798C32.0499 12.5798 33.0299 12.4198 33.9099 13.0498C34.7399 13.6398 35.1099 14.7398 34.4399 15.6798C33.7599 16.6498 32.5599 16.7498 31.3799 15.9198C30.4899 15.2898 30.0099 14.4798 29.8799 13.7098C29.7799 13.0698 29.8999 12.4098 30.2299 11.7898C30.3299 11.5898 30.4299 11.4298 30.5099 11.3198L31.0299 11.6698ZM33.5199 13.6898C32.8699 13.2298 32.2199 13.3298 31.8199 13.8898C31.5599 14.2598 31.5499 14.7598 31.7599 15.1598C31.7999 15.2498 31.8699 15.3398 31.9799 15.4198C32.7299 15.9298 33.5299 15.9798 33.9799 15.3398C34.3499 14.8098 34.1599 14.1498 33.5199 13.6898Z",
    fill: "#00CECE"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7399 8.95991C37.2499 10.0899 37.6699 11.2699 36.9299 12.2499C36.2799 13.1199 35.0299 13.0999 33.5499 12.0199C32.0599 10.9099 31.7199 9.65992 32.3899 8.74992C33.0999 7.81992 34.3299 7.90991 35.7399 8.95991ZM34.0099 11.4199C35.1599 12.2799 36.0899 12.4099 36.4899 11.8699C36.9499 11.2599 36.4499 10.4299 35.3199 9.5799C34.2299 8.7599 33.2999 8.50992 32.8399 9.12992C32.4399 9.65992 32.7999 10.5199 34.0099 11.4199Z",
    fill: "#00CECE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBoardLeft);
export default __webpack_public_path__ + "static/media/nav-board-left.170e2ecf3487411026f5dd76dfb31a51.svg";
export { ForwardRef as ReactComponent };